// src/KurumChangePasswordPage.js
import React, { useState } from "react";
import axios from "axios";

export default function KurumChangePasswordPage() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  /* =====================================================
     🔐 SUBMIT
     POST /api/kurum-passport/change-password
  ===================================================== */
  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);

    if (!oldPassword || !newPassword || !newPassword2) {
      setMsg({ type: "error", text: "Tüm alanlar zorunludur." });
      return;
    }

    if (newPassword !== newPassword2) {
      setMsg({ type: "error", text: "Yeni şifreler uyuşmuyor." });
      return;
    }

    if (newPassword.length < 6) {
      setMsg({ type: "error", text: "Yeni şifre en az 6 karakter olmalıdır." });
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        "/api/kurum-passport/change-password",
        {
          oldPassword,
          newPassword,
          newPassword2,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMsg({
        type: "success",
        text: "Şifreniz başarıyla değiştirildi.",
      });

      setOldPassword("");
      setNewPassword("");
      setNewPassword2("");

    } catch (err) {
      setMsg({
        type: "error",
        text:
          err?.response?.data?.message ||
          "Şifre değiştirilemedi. Eski şifre hatalı olabilir.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0B1E3F] via-[#0F2D59] to-[#1B3C82] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">

        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">
          Şifre Değiştir
        </h1>

        <p className="text-center text-gray-500 text-sm mb-6">
          Kurum paneli hesabınız için yeni şifre belirleyin
        </p>

        {msg && (
          <div
            className={`mb-4 text-sm text-center font-semibold p-3 rounded-lg ${
              msg.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {msg.text}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4">
          <input
            type="password"
            placeholder="Mevcut Şifre"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-600"
            required
          />

          <input
            type="password"
            placeholder="Yeni Şifre"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-600"
            required
          />

          <input
            type="password"
            placeholder="Yeni Şifre (Tekrar)"
            value={newPassword2}
            onChange={(e) => setNewPassword2(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-600"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold transition"
          >
            {loading ? "Kaydediliyor…" : "Şifreyi Güncelle"}
          </button>
        </form>

      </div>
    </div>
  );
}
